// Whether a message says one of a person's keywords, as the server decides
// (messaging.MatchesKeyword): case aside, as a whole word or phrase, where a
// word boundary is needed only between two letters or digits of scripts
// written with spaces.

const word = /[\p{L}\p{N}_]/u;
const unspaced = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}\p{Script=Thai}]/u;
const spaced = (c: string | undefined) => !!c && word.test(c) && !unspaced.test(c);

export function matchesKeyword(text: string, keyword: string): boolean {
  const t = text.toLowerCase();
  const k = keyword.trim().toLowerCase();
  if (!k) return false;
  const chars = [...k];
  const first = chars[0];
  const last = chars[chars.length - 1];
  for (let from = 0; ; ) {
    const i = t.indexOf(k, from);
    if (i < 0) return false;
    const before = [...t.slice(0, i)].pop();
    const after = [...t.slice(i + k.length)][0];
    if (!(spaced(first) && spaced(before)) && !(spaced(last) && spaced(after))) return true;
    from = i + 1;
  }
}

export const saysKeyword = (text: string, keywords: string[]) => keywords.some((k) => matchesKeyword(text, k));
